module.exports = __webpack_public_path__ + "static/media/notfound.3045987c.jpeg";